const CUSTOMER_STATUS_LABEL_MAP = {
  pending_supervisor_approval: 'Open',
  supervisor_approved: 'Resolved',
  resolved: 'Resolved',
};

const CUSTOMER_STATUS_STYLE_MAP = {
  pending_supervisor_approval: 'open',
  supervisor_approved: 'resolved',
  resolved: 'resolved',
};

export function normalizeTicketStatusToken(value) {
  return String(value ?? '').trim().toLowerCase().replace(/[\s-]+/g, '_');
}

export function resolveTicketStatusCode(ticket, statuses = []) {
  if (!ticket) return '';

  // Prefer master status code via statusId — ticket.statusCode may be absent or a display name.
  if (ticket.statusId != null && Array.isArray(statuses) && statuses.length > 0) {
    const matched = statuses.find((s) => String(s.statusId) === String(ticket.statusId));
    if (matched) {
      const masterCode = normalizeTicketStatusToken(matched.statusCode || matched.code);
      if (masterCode) return masterCode;
    }
  }

  const statusCode = normalizeTicketStatusToken(ticket.statusCode);
  if (statusCode) return statusCode;

  return normalizeTicketStatusToken(ticket.status);
}

/** Customer-visible status label; internal workflow fields on the ticket are unchanged. */
export function getCustomerFacingTicketStatusLabel(ticket, statuses = []) {
  const code = resolveTicketStatusCode(ticket, statuses);
  if (CUSTOMER_STATUS_LABEL_MAP[code]) {
    return CUSTOMER_STATUS_LABEL_MAP[code];
  }
  return ticket?.status || ticket?.statusCode || 'open';
}

/** Badge/icon/color key aligned with existing getStatusColor switches. */
export function getCustomerFacingTicketStatusStyleKey(ticket, statuses = []) {
  const code = resolveTicketStatusCode(ticket, statuses);
  if (CUSTOMER_STATUS_STYLE_MAP[code]) {
    return CUSTOMER_STATUS_STYLE_MAP[code];
  }
  return ticket?.status || ticket?.statusCode || 'open';
}
